import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const getPhotoAlbum = createAsyncThunk(
	"photoAlbum",
	async ({ id, organiserID, eventID, language }) => {
		const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
		const REACT_APP_ENV = process.env.REACT_APP_ENV;
		const REACT_APP_API_URL_TEST = process.env.REACT_APP_API_URL_TEST;

		try {
			const url =
				REACT_APP_ENV === "prod" ? REACT_APP_API_URL : REACT_APP_API_URL_TEST;
			const res = await axios({
				method: "get",
				url: `${url}/api/photo-album/public/getById/${organiserID}/${eventID}/${id}/${language}`,

				headers: {
					"Content-Type": "application/json",
				},
			});
			return res.data;
		} catch (error) {
			throw new Error("Bir Hata Oluştu: {getPhotoAlbum}");
		}
	}
);

const initialState = {
	error: null,
	loading: null,
	photoAlbum: null,
};

export const photoAlbumSlice = createSlice({
	name: "photoAlbum",
	initialState,
	reducers: {
		resetPhotoAlbum: (state) => {
			state.photoAlbum = null;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getPhotoAlbum.pending, (state) => {
				state.loading = true;
				state.photoAlbum = null;
			})
			.addCase(getPhotoAlbum.fulfilled, (state, actions) => {
				state.photoAlbum = actions.payload;
				state.loading = false;
			})
			.addCase(getPhotoAlbum.rejected, (state, actions) => {
				state.loading = false;
				state.photoAlbum = null;
			});
	},
});

export const { resetPhotoAlbum } = photoAlbumSlice.actions;
export default photoAlbumSlice.reducer;
